import { useDispatch } from 'react-redux';
import { actions as cmsActions } from '../../../reducers/cms.reducer';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import Input from './Input.react';
var AltTag = function AltTag(_ref) {
  var altTag = _ref.altTag,
    onChange = _ref.onChange,
    tagType = _ref.tagType,
    appType = _ref.appType,
    _ref$pageID = _ref.pageID,
    pageID = _ref$pageID === void 0 ? null : _ref$pageID,
    _ref$articleID = _ref.articleID,
    articleID = _ref$articleID === void 0 ? null : _ref$articleID,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? null : _ref$selected,
    _ref$componentID = _ref.componentID,
    componentID = _ref$componentID === void 0 ? null : _ref$componentID,
    _ref$sectionID = _ref.sectionID,
    sectionID = _ref$sectionID === void 0 ? null : _ref$sectionID,
    _ref$imageID = _ref.imageID,
    imageID = _ref$imageID === void 0 ? null : _ref$imageID;
  var dispatch = useDispatch();
  return /*#__PURE__*/React.createElement("div", {
    className: "alt-tag"
  }, /*#__PURE__*/React.createElement(Input, {
    value: altTag,
    onChange: onChange,
    placeholder: "Alt Tag"
  }), /*#__PURE__*/React.createElement("div", {
    className: "alt-tag__save",
    onClick: function onClick() {
      if (appType === 'pos') dispatch({
        type: cmsActions.altTag,
        payload: {
          pageID: pageID,
          articleID: articleID,
          blobType: tagType,
          altTag: altTag,
          selected: selected
        }
      });else if (appType === 'ppc') dispatch({
        type: ppcActions.altTag,
        payload: {
          pageID: pageID,
          componentID: componentID,
          sectionID: sectionID,
          imageID: imageID,
          blobType: tagType,
          altTag: altTag
        }
      });
    }
  }, /*#__PURE__*/React.createElement("span", null, "Save")));
};
export default AltTag;